export const MAX_ATTACHMENT_FILE_SIZE = 20 * 1024 * 1024; // 20MB
